import { environment } from 'environments/environment';

export function assertNever(val: never): void;
export function assertNever<T>(val: never, defaultValue: T): T;
export function assertNever<T>(val: never, defaultValue?: T): T | undefined {
  failOnStaging(`assertNever, parameter should never have a value, but instead it is '${val}'`);

  return defaultValue;
}

export function failOnStaging(error: string) {
  if (environment.production) {
    console.error(error);
  } else {
    throw Error(error);
  }
}
